import GlobalHeader from './GlobalHeader';

export default GlobalHeader;
export * from './GlobalHeader';
